import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveWidgetContainer } from "../../components/ActiveWidgetContainer/ActiveWidgetContainer";

const ActiveWidgetScreen = () => {
  return (
    <ScreenLayout>
      <ActiveWidgetContainer />
    </ScreenLayout>
  );
};

export default ActiveWidgetScreen;
